// extracted by mini-css-extract-plugin
module.exports = {"noIcon":"ArchiveTarget_noIcon__1UlJ3","image":"ArchiveTarget_image__2xIDS"};